/**
 * Get URL to item icon.
 * @param iconName
 * @param size
 * @returns
 */
export const getItemIconUrl = (iconName: string, size: "small" | "medium" | "large" = "small"): string => {
    iconName = iconName.toLowerCase();
    return `https://wow.zamimg.com/images/wow/icons/${size}/${iconName}.jpg`;
};
